import React, { useEffect, useRef, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import OrderdetailShimmer from "../components/Preloader/OrderdetailShimmer";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import { GoMoon, GoSun } from "react-icons/go";
import { SlCalender } from "react-icons/sl";
import orderdish from "../assets/images/svgs/cards/orders.svg";
import { CiEdit } from "react-icons/ci";
import phone from "../assets/images/svgs/other/callphone.svg";
import whatsapp from "../assets/images/svgs/other/whatsapp.svg";
import { useDispatch, useSelector } from "react-redux";
import { getOrderDetailById } from "../redux/thunks/orderThunk";
import { getMealDetailById } from "../redux/thunks/mealsetupThunk";
import { getCustomerDataDeliverAnOrder } from "../redux/thunks/orderCustomerThunk";
import DeliveryIcon from "../assets/images/svgs/cards/delivery.svg";
import { decryptId, encryptId } from "../utils/urlCrypto";
import {
  ChevronDown,
  ChevronUp,
  Copy,
  SquareArrowOutUpRight,
} from "lucide-react";
import "leaflet/dist/leaflet.css";

import ImagePreview from "../components/ui/ImagePreview";
import toast from "react-hot-toast";
import MapModal from "../components/Modals/MapModal";
import { FaArrowLeft } from "react-icons/fa";
const Orderdetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isDetailOpen, setIsDetailsOpen] = useState(false);
  const { orderId: paramOrderId } = useParams();
  const { addressId } = useSelector((state) => state.customerAddress);
  const { isOrderListing } = useSelector((state) => state.order);
  const { isMealLoading } = useSelector((state) => state.setMeal);
  const order_id = decryptId(paramOrderId);
  const [details, setDetails] = useState({});
  const [mealId, setMealId] = useState(null);
  const [mealDetail, setMealDetail] = useState();
  const [mealImg, setMealImg] = useState();
  const [customerId, setCustomerId] = useState(null);
  const [PayStatus, setPayStatus] = useState(null);
  const [PayType, setPayType] = useState(null);
  const [OrderRemark, setOrderRemark] = useState(null);
  const [deliveryOrderRemark, setDeliveryOrderRemark] = useState(null);
  const [OrderProof, setOrderProof] = useState(null);
  const [isMapOpen, setIsMapOpen] = useState(false);

  // dispatch an api
  useEffect(() => {
    // console.log("The order id is", order_id);
    const payload = {
      order_id: order_id,
    };
    dispatch(getOrderDetailById(payload))
      .unwrap()
      .then((res) => {
        // console.log(res.data);
        const getAllDetails = res.data;
        // console.log("The get all details is :", getAllDetails);
        setDetails(getAllDetails);
        const getMealId = getAllDetails.meal.meal_id;
        setMealId(getMealId);

        const getCustomerID = getAllDetails.customer.customer_id;
        setCustomerId(getCustomerID);
      });
  }, [dispatch]);

  useEffect(() => {
    const mPayload = {
      meal_id: mealId,
    };

    dispatch(getMealDetailById(mPayload))
      .unwrap()
      .then((res) => {
        // console.log("The res of meal detail is :", res.data);

        const getAllMeal = res.data;
        setMealDetail(getAllMeal);
        const getMealImg = getAllMeal?.meal_other_images?.find(
          (img) => img.is_cover_image === 1,
        )?.image_url;
        // console.log("The meals price is :", getAllMeal.price_per_meal);
        // console.log("The meal image is :", getMealImg);
        setMealImg(getMealImg);
      });
  }, [mealId, dispatch]);

  useEffect(() => {
    const payload = {
      order_id: order_id,
    };
    dispatch(getCustomerDataDeliverAnOrder(payload))
      .unwrap()
      .then((res) => {
        // console.log("The res of getting delivery detail is :", res.data);
        setPayStatus(res.data?.payment?.payment_status);
        setPayType(res.data?.payment?.payment_type);
        setOrderRemark(res.data?.order_remark);
        setDeliveryOrderRemark(res.data?.order_delivery_remark);
        setOrderProof(res.data?.order_delivery_proof_image);
      });
  }, [dispatch, order_id]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const onEditClick = (orderId) => {
    navigate(`/edit-order/${encryptId(orderId)}`, {
      state: {
        addressId: addressId,
      },
    });
  };

  const handleShare = () => {
    const message = `Hi, ${details?.customer?.customer_name}  `;

    const encodedMessage = encodeURIComponent(message);

    const phone = `${details?.customer?.country_code}${details?.customer?.customer_contact_no}`;

    const url = `https://wa.me/${phone}?text=${encodedMessage}`;

    window.open(url, "_blank");
  };

  const getInitials = (name = "") => {
    const words = name.trim().split(" ").filter(Boolean);

    if (words.length === 0) return "";

    // If only one word → return first 2 letters
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // If multiple words → first letter of first & second word
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };
  const address = details?.customer?.addresses?.[0]; 
  const rawValue = Number(details?.discount_and_other_charges || 0);
  const isDiscount = rawValue < 0;

  return (
    <>
      {isOrderListing || isMealLoading ? (
        <OrderdetailShimmer />
      ) : (
        <>
          <section className="relative min-h-screen max-w-7xl mx-auto px-4 py-6">
            <DecorativeSquares />

            {/* Header */}
            <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
              <button
                onClick={handleGoBack}
                className="flex items-center p-2 rounded-full hover:bg-gray-100"
              >
                <FaArrowLeft size={20} />
              </button>

              <h1 className="mx-auto text-2xl font-semibold text-gray-900">
                Order Details
              </h1>
            </div>

            {/* Center Card Wrapper */}
            <div className="px-0 md:px-4 mt-8">
              <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
                <div className="flex justify-between">
                  <div className="flex items-center gap-4">
                    {/* Avatar */}
                    <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 text-sm rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                      {getInitials(details?.customer?.customer_name)}
                    </div>
                    {/* User Info */}
                    <div className="flex flex-col">
                      <h2 className="text-sm md:text-base font-semibold text-gray-900">
                        {details?.customer?.customer_name}
                      </h2>

                      <p className="mt-1 flex items-center gap-2 text-[12px] md:text-sm text-gray-600">
                        <FiPhoneCall />+{details?.customer?.country_code}{" "}
                        {details?.customer?.customer_contact_no}
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <a
                      onClick={() => handleShare()}
                      rel="noopener noreferrer"
                      className="rounded-full h-10 w-10 md:h-14 md:w-14 p-3 md:p-4 items-center flex justify-center text-center border-gray-200 bg-[#3CBBF3]/20 cursor-pointer"
                    >
                      <img className="w-5 h-5" src={whatsapp} alt="whatsapp" />
                    </a>
                    <a  href={`tel:+${details?.customer?.country_code}${details?.customer?.customer_contact_no}`}
                     className="rounded-full h-10 w-10 md:h-14 md:w-14 p-3 md:p-4 items-center flex justify-center text-center border-gray-200 bg-[#3021C7]/20 cursor-pointer">
                      <img className="w-5 h-5" src={phone} alt="call" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center text-center mt-3">
              <span
                className={`text-sm rounded-full w-auto px-3 py-1 border font-medium
    ${
      details?.status === "pending"
        ? "bg-[#FFF0D1] text-[#E9A626] border-[#E9A626] animate-pulse"
        : details?.status === "delivered"
          ? "bg-green-100 text-green-600 border-green-600"
          : details?.status === "cancelled"
            ? "bg-red-100 text-red-600 border-red-600"
            : "bg-gray-100 text-gray-600 border-gray-400"
    }
  `}
              >
                {details?.status}
              </span>
            </div>
            <div className="flex justify-center mt-2 mb-2">
              <span className="text-sm text-gray-500 text-center flex gap-2 items-center">
                #{details?.order_unique_id}
                <Copy
                  size={15}
                  className="cursor-pointer hover:text-black transition"
                  onClick={() => {
                    if (!details?.order_unique_id) return;

                    navigator.clipboard.writeText(details.order_unique_id);
                    toast.success("Order ID copied!");
                  }}
                />
              </span>
            </div>
            {/* Main details */}
            <div className="md:px-4 mt-8">
              <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-3 md:p-6 shadow-sm">
                <div className="flex items-center gap-4">
                  {/* Avatar */}
                  <div className="flex items-center justify-center rounded-md bg-[#FFEFEB] text-[#FF6943] font-semibold">
                    <ImagePreview
                      src={mealImg}
                      alt="dishImg"
                      className="object-cover w-12 h-12 rounded-md"
                    />
                  </div>

                  {/* User Info */}
                  <div className="flex flex-col">
                    <h2 className="text-base font-semibold text-gray-900">
                      {mealDetail?.meal_name || "Unknown Meal"}
                    </h2>

                    <p className="mt-1 flex items-center gap-2 text-sm text-[#FF6943] font-bold">
                      {details?.currency_symbol}
                      {details?.price_per_meal}
                    </p>
                  </div>
                </div>
                <div className="mt-4 flex justify-start gap-4">
                  <div
                    className={`rounded-full  w-24 p-1 px-2 flex justify-center items-center gap-2 ${details?.meal_timing === "dinner" ? "bg-[#B472FF]/10" : "bg-[#FF6943]/10"}`}
                  >
                    {details?.meal_timing === "lunch" ? (
                      <GoSun size={12} className="text-[#FF6943] font-medium" />
                    ) : (
                      <GoMoon
                        size={12}
                        className="text-purple-800 font-medium"
                      />
                    )}
                    <p
                      className={`text-xs font-medium  ${details?.meal_timing === "dinner" ? "text-purple-800" : "text-[#FF6943]"}`}
                    >
                      {details?.meal_timing}
                    </p>
                  </div>
                  <div className="mt-1 flex justify-center gap-2 ">
                    <SlCalender size={12} />
                    <p className="text-xs">{details?.order_date}</p>
                  </div>
                </div>
                <div className="border-b border-gray-200 mt-6 mb-2"></div>
                <div className="flex justify-between">
                  <p className="text-gray-900 text-base font-semibold">
                    Order details
                  </p>
                  {isDetailOpen ? (
                    <button
                      className="mt-1 cursor-pointer duration-500 ease-in-out transition-all"
                      onClick={() => setIsDetailsOpen(false)}
                    >
                      <ChevronUp size={20} className="font-bold" />
                    </button>
                  ) : (
                    <button
                      className="mt-1 cursor-pointer duration-500 ease-in-out transition-all"
                      onClick={() => setIsDetailsOpen(true)}
                    >
                      <ChevronDown size={20} className="font-bold" />
                    </button>
                  )}
                </div>
                {isDetailOpen && (
                  <>
                    <div className="mt-4 transition-all duration-500 ease-in-out">
                      {/* Order header */}
                      <div className="flex justify-between gap-4">
                        <div className="flex gap-4">
                          <img
                            src={orderdish}
                            alt="orderDish"
                            className="h-5 w-5 "
                          />
                          <p className="text-gray-700 text-sm text-start font-medium">
                            {details?.quantity} x {mealDetail?.meal_name}
                          </p>
                        </div>
                        {details?.status === "pending" && (
                          <button
                            onClick={() => onEditClick(details?.order_id)}
                            className="border border-gray-200 p-2 rounded-md cursor-pointer"
                          >
                            <CiEdit />
                          </button>
                        )}
                      </div>
                      {/* Order details */}
                      <div className="relative -mx-4 sm:mx-0 overflow-x-auto mt-4">
                        <div className="w-full md:min-w-[640px]  rounded-lg border border-gray-200 bg-white">
                          <table className="w-full text-left text-sm sm:text-base text-gray-800">
                            {/* Header */}
                            <thead className="bg-gray-50">
                              {details?.extra_items?.length > 0 && (
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 text-start text-base sm:text-lg font-semibold"
                                  >
                                    Extra items
                                  </th>
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 text-end text-base sm:text-lg font-semibold text-[#FF6943]"
                                  >
                                    {details?.currency_symbol}
                                    {Number(details?.extra_total).toFixed(2)}
                                  </th>
                                </tr>
                              )}
                            </thead>

                            {/* Body */}
                            <tbody className="divide-y">
                              {details?.extra_items?.length > 0 &&
                                details.extra_items.map((item, i) => (
                                  <tr key={i}>
                                    <td colSpan={2} className="py-2 px-4">
                                      <div className="flex items-center gap-2 whitespace-nowrap">
                                        <span className="inline-block w-2 h-2 rounded-full bg-[#FF6943]" />
                                        <span>{`${item.quantity} x ${item.name}`}</span>
                                      </div>
                                    </td>
                                    <td className="py-2 px-4 text-end font-semibold whitespace-nowrap">
                                      {details?.currency_symbol}
                                      {Number(item.amount).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}

                              {/* Charges */}

                              {details?.delivery_type === "delivery" && (
                                <tr className="bg-gray-50">
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 font-semibold"
                                  >
                                    Delivery charges
                                  </th>
                                  <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                                    {details?.currency_symbol}
                                    {Number(details?.delivery_charges).toFixed(
                                      2,
                                    )}
                                  </th>
                                </tr>
                              )}
                              {details?.discount_and_other_charges ===
                              0 ? null : (
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 font-semibold"
                                  >
                                    {isDiscount ? "Discount" : "Other Charges"}
                                  </th>

                                  <th
                                    className={`py-3 px-4 text-end font-semibold ${
                                      isDiscount
                                        ? "text-[#1CCB50]"
                                        : "text-red-500"
                                    }`}
                                  >
                                    {isDiscount
                                      ? `- ${details?.currency_symbol}`
                                      : `+ ${details?.currency_symbol}`}
                                    {Math.abs(rawValue).toFixed(2)}
                                  </th>
                                </tr>
                              )}

                              <tr className="bg-orange-50">
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-semibold text-[#FF6943]"
                                >
                                  Total Order Amount
                                </th>
                                <th className="py-3 px-4 text-end font-semibold text-[#FF6943]">
                                  {details?.currency_symbol}
                                  {Number(details?.order_amount).toFixed(2)}
                                </th>
                              </tr>
                            </tbody>

                            {/* Footer */}
                            <tfoot className="border-t bg-white">
                              <tr>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-medium"
                                >
                                  Plan Type
                                </th>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 text-end font-semibold"
                                >
                                  {details?.meal_plan_type}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-medium"
                                >
                                  Start Date
                                </th>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 text-end font-semibold"
                                >
                                  {details?.order_date}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-medium"
                                >
                                  Meal Timing
                                </th>

                                <td
                                  colSpan={2}
                                  className="py-3 px-4 text-end font-semibold"
                                >
                                  {details?.meal_timing && (
                                    <div className="flex justify-end items-center gap-2">
                                      {details.meal_timing.toLowerCase() ===
                                      "lunch" ? (
                                        <GoSun
                                          size={17}
                                          className="font-bold"
                                        />
                                      ) : (
                                        <GoMoon
                                          size={17}
                                          className="font-bold"
                                        />
                                      )}

                                      <span className="capitalize">
                                        {details.meal_timing}
                                      </span>
                                    </div>
                                  )}
                                </td>
                              </tr>

                              <tr>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-medium"
                                >
                                  Delivery Type
                                </th>

                                <td
                                  colSpan={2}
                                  className="py-3 px-4 text-end font-semibold"
                                >
                                  {details?.delivery_type && (
                                    <div className="flex justify-end items-center gap-2">
                                      <img
                                        src={DeliveryIcon}
                                        alt="delivery icon"
                                        className="h-4 w-4 object-contain"
                                      />

                                      <span className="capitalize">
                                        {details.delivery_type === "delivery"
                                          ? "Home Delivery"
                                          : "Pick Up"}
                                      </span>
                                    </div>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  colSpan={2}
                                  className="py-3 px-4 font-medium"
                                >
                                  Time slot
                                </th>
                                {details?.time_slot ? (
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 text-end font-semibold"
                                  >
                                    {details?.time_slot}
                                  </th>
                                ) : (
                                  <th
                                    colSpan={2}
                                    className="py-3 px-4 text-end font-semibold"
                                  >
                                    -
                                  </th>
                                )}
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                    {details?.delivery_type === "delivery" && (
                      <div
                        onClick={() => setIsMapOpen(true)}
                        className="mt-4 flex justify-start items-center gap-2 cursor-pointer hover:text-blue-600 transition"
                      >
                        <CiLocationOn size={20} className="text-[#FF6943]" />
                        <p className="text-start text-[#FF6943] text-[12px] md:text-sm">
                          {address?.address_1}
                        </p>
                        <SquareArrowOutUpRight
                          size={15}
                          className="text-[#FF6943] text-end"
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="mb-8 space-y-6 max-w-7xl mt-2 mx-auto">
                {/* Delivery Proof Card */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {OrderProof && (
                    <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
                      <h2 className="text-lg font-semibold text-gray-900 mb-4">
                        Delivery Proof
                      </h2>

                      <div className="w-full h-72 bg-gray-100 rounded-xl overflow-hidden border">
                        <ImagePreview
                          src={OrderProof}
                          alt="Delivery Proof"
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            console.log("Image failed to load:", OrderProof);
                            e.target.src =
                              "https://via.placeholder.com/600x400?text=No+Image+Found";
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {/* Order Remark */}
                  {deliveryOrderRemark && (
                    <div className="mx-auto w-full    max-w-7xl bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                      <h2 className="text-lg font-semibold text-gray-900 mb-2">
                        Delivery Remark
                      </h2>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {deliveryOrderRemark}
                      </p>
                    </div>
                  )}
                </div>
                {/* Payment Info */}
                {details?.status === "delivered" && (
                  <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                    <h2 className="text-lg font-semibold text-gray-900 mb-3">
                      Payment Type
                    </h2>

                    {PayType ? (
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {PayType}
                      </p>
                    ) : (
                      <p className="text-gray-600 text-sm leading-relaxed">
                        No Payment done
                      </p>
                    )}
                  </div>
                )}

                <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                  <h2 className="text-lg font-semibold text-gray-900 mb-3">
                    Order Remark
                  </h2>
                  <div className="flex justify-between items-center mt-3 text-sm">
                    {OrderRemark ? (
                      <span className="font-medium text-gray-400 capitalize">
                        {OrderRemark}
                      </span>
                    ) : (
                      <span className="font-medium text-gray-400 capitalize">
                        No order Remark added
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <MapModal
            isOpen={isMapOpen}
            onClose={() => setIsMapOpen(false)}
            address={address}
            actualAddress={address?.address_1}
          />
        </>
      )}
    </>
  );
};

export default Orderdetail;
